<template>
    <div>

        <div v-if="fields.includes('first_name')" class="form-group text">
            <label for="first-name" class="control-label">First Name</label>
            <input
                class="form-control"
                id="first-name"
                @input="updateField"
                name="first_name"
                data-vv-as="first name"
                type="text"
                :value="first_name"
                v-validate="{
                    required: nameIsRequired,
                }"
            >
            <div v-show="vErrors.has('first_name')"
                 class="text-danger">
                {{ vErrors.first('first_name') }}
            </div>
        </div>
        <div v-if="fields.includes('last_name')" class="form-group text">
            <label for="last-name" class="control-label">Last Name</label>
            <input
                class="form-control"
                id="last-name"
                @input="updateField"
                name="last_name"
                data-vv-as="last name"
                type="text"
                :value="last_name"
                v-validate="{
                    required: nameIsRequired,
                }"
            >
            <div v-show="vErrors.has('last_name')"
                 class="text-danger">
                {{ vErrors.first('last_name') }}
            </div>
        </div>
        <div v-if="fields.includes('email')" class="form-group email">
            <label for="email" class="control-label">Email</label>
            <input :value="email" @input="updateField" type="email" name="email" id="email" class="form-control">
        </div>


        <div v-if="fields.includes('line_1')" class="form-group text">
            <label for="line-1" class="control-label">Address Line 1</label>
            <input
                v-validate="'required'"
                data-vv-as="Address line 1"
                @input="updateField"
                type="text"
                name="line_1"
                id="line-1"
                class="form-control"
                v-model="internal_line_1"
                :class="[vErrors.has('post_code') ? 'is-invalid' : '']">
            <div v-show="vErrors.has('line_1')" class="text-danger">
                {{ vErrors.first('line_1') }}
            </div>
        </div>


        <div v-if="fields.includes('line_2')" class="form-group text">
            <label for="line-2" class="control-label">Address Line 2</label>
            <input :value="line_2" @input="updateField" type="text" name="line_2" id="line-2" class="form-control">
        </div>
        <div v-if="fields.includes('town')" class="form-group text">
            <label for="town" class="control-label">Town</label>
            <input :value="town" @input="updateField" type="text" name="town" id="town" class="form-control">
        </div>
        <div v-if="fields.includes('county')" class="form-group text">
            <label for="county" class="control-label">County</label>
            <input :value="county" @input="updateField" type="text" name="county" id="county" class="form-control">
        </div>
        <div v-if="fields.includes('post_code')" class="form-group text">
            <label for="post-code" class="control-label">Post Code</label>
            <input
                   v-validate="'required'"
                   data-vv-as="Post code"
                   @input="updateField"
                   type="text"
                   name="post_code"
                   id="post-code"
                   class="form-control"
                   v-model="internal_post_code"
                   :class="[vErrors.has('post_code') ? 'is-invalid' : '']">
            <div v-show="vErrors.has('post_code')" class="text-danger">
                {{ vErrors.first('post_code') }}
            </div>
        </div>
        <div v-if="fields.includes('country')" class="form-group text">
            <label for="country" class="control-label">Country</label>
            <input :value="country" @input="updateField" type="text" name="country" id="country" class="form-control">
        </div>
    </div>
</template>

<script>
export default {
    inject: ['$validator'],
    props: {
        country: {
            default: null,
            required: false,
            type: String,
        },
        county: {
            default: null,
            required: false,
            type: String,
        },
        email: {
            default: null,
            required: false,
            type: String,
        },
        fields: {
            required: true,
            type: Array,
        },
        first_name: {
            default: null,
            required: false,
            type: String,
        },
        last_name: {
            default: null,
            required: false,
            type: String,
        },
        line_1: {
            default: null,
            required: false,
            type: String,
        },
        line_2: {
            default: null,
            required: false,
            type: String,
        },
        nameIsRequired: {
            default: false,
            required: false,
            type: Boolean,
        },
        post_code: {
            default: null,
            required: false,
            type: String,
        },
        town: {
            default: null,
            required: false,
            type: String,
        },
    },
    data() {
        return {
            internal_line_1: this.line_1, //To play nice with vee-validate
            internal_post_code: this.post_code, //To play nice with vee-validate
        }
    },
    methods: {
        updateAddress(newVals) {
            let address = Object.assign({}, this.$props);
            address = Object.assign(address, newVals);
            this.$emit(`updateAddress`, newVals);
        },
        updateField(event) {
            let {name, value} = event.target;
            this.updateAddress({[name]: value});
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Donations/Form/Address.vue